import React, { MouseEventHandler, useCallback } from 'react';

import { Icon, IconSize } from 'app/design-system/components/Icon';

import { useLeftMenuStateAPI } from '../hooks/left-menu-state-api';

import styles from '../styles/LeftMenu.module.scss';

const ExpandControl: React.FC = () => {
  const { expanded, toggleExpanded } = useLeftMenuStateAPI();

  const handleClick = useCallback<MouseEventHandler>((event) => {
    event.preventDefault();
    event.stopPropagation();
    toggleExpanded();
  }, [toggleExpanded]);

  return (
    <div className={styles.control}
         data-test="control-layer">
      <a href="#"
         onClick={handleClick}>
        <Icon icon={expanded ? 'chevron-left' : 'chevron-right'}
              size={IconSize.DEFAULT} />
      </a>
    </div>
  );
};

export default ExpandControl;
